module.exports = __webpack_public_path__ + "static/media/pub.ed019a58.png";